module.exports = __webpack_public_path__ + "static/media/coming-soon.89beec5d.svg";